var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14V15H23V14C23 13.4688 23.4375 13 24 13C24.5312 13 25 13.4688 25 14V15H26.5C27.3125 15 28 15.6875 28 16.5V18H14V16.5C14 15.6875 14.6562 15 15.5 15H17V14C17 13.4688 17.4375 13 18 13C18.5312 13 19 13.4688 19 14ZM14 19H28V27.5C28 28.3438 27.3125 29 26.5 29H15.5C14.6562 29 14 28.3438 14 27.5V19ZM21.2812 20.8438C21.1562 20.625 20.8125 20.625 20.6875 20.8438L19.9688 22.3438L18.3125 22.5938C18.0312 22.625 17.9375 22.9688 18.125 23.1562L19.3125 24.3125L19.0312 25.9375C19 26.2188 19.2812 26.4062 19.5 26.2812L20.9688 25.5L22.4688 26.2812C22.6875 26.4062 22.9688 26.2188 22.9375 25.9375L22.6562 24.3125L23.8438 23.1562C24.0312 22.9688 23.9375 22.625 23.6562 22.5938L22 22.3438L21.2812 20.8438Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledEvent);
export default __webpack_public_path__ + "static/media/filledEvent.38b2a4055c524cb64a05621949a31ef5.svg";
export { ForwardRef as ReactComponent };